module.exports = __webpack_public_path__ + "img/gpt-vs-selfpetition-output.e17fc441.svg";